'use strict';

function getValueTransition(transition, key) {
    return (transition?.[key] ??
        transition?.["default"] ??
        transition);
}

exports.getValueTransition = getValueTransition;
//# sourceMappingURL=get-value-transition.cjs.map
